import { kioskApiGetFormsBySoarEnterprise } from "../../Kiosk/kioskApi"

export async function getKioskTemplateUsageStatus({
  kiosk,
  templateName,
  enterpriseId,
  getKioskToken,
}) {
  // Only kiosk-enabled templates can be used in Kiosk forms.
  if (kiosk !== 1) {
    return {
      shouldCheck: false,
      isInUse: false,
      formsUsingTemplate: [],
      reason: "template_not_kiosk_enabled",
    }
  }

  // Required inputs to fetch form usage.
  if (!templateName || !enterpriseId || !getKioskToken) {
    return {
      shouldCheck: true,
      isInUse: false,
      formsUsingTemplate: [],
      reason: "missing_required_inputs",
    }
  }

  // Kiosk APIs require the kiosk service token.
  const kioskToken = getKioskToken()
  if (!kioskToken) {
    return {
      shouldCheck: true,
      isInUse: false,
      formsUsingTemplate: [],
      reason: "missing_kiosk_token",
    }
  }

  // Fetch all forms across kiosk organizations in the enterprise in one request.
  const formsResponse = await kioskApiGetFormsBySoarEnterprise(
    kioskToken,
    enterpriseId
  )

  // Endpoint returns { forms: FormEntry[] }.
  const forms = formsResponse?.forms || []

  // Usage is determined by matching the form's stored template name across enterprise forms.
  const formsUsingTemplate = forms.filter(
    (form) => form.soarTemplateName === templateName
  )

  return {
    shouldCheck: true,
    isInUse: formsUsingTemplate.length > 0,
    formsUsingTemplate,
    reason: null,
  }
}